module.exports = __webpack_public_path__ + "static/assets/75dfdd77f40989c76f8be89442c48f57.png";